import api from "./axios";

export const registerEvent = (eventId, data) =>
  api.post(`/api/events/${eventId}/register/`, data);

// Admin
export const adminGetEvents = () => api.get("/api/admin/events/");
export const adminGetEvent = (id) => api.get(`/api/admin/events/${id}/`);
export const adminCreateEvent = (data) => api.post("/api/admin/events/", data);
export const adminUpdateEvent = (id, data) => api.put(`/api/admin/events/${id}/`, data);
export const adminDeleteEvent = (id) => api.delete(`/api/admin/events/${id}/`);
export const adminGetEventRegistrations = (id) => api.get(`/api/admin/events/${id}/registrations/`);